import React from "react";

const Generator = (props) => {
    return <><h1>Generator</h1></>
}

export default Generator;
